import * as React from 'react';
import { CardElement, useElements } from '@stripe/react-stripe-js';
import { useState } from 'react';
import {
  StripeCardElement,
  StripeCardElementChangeEvent,
  StripeCardElementOptions,
  StripeCardNumberElement,
} from '@stripe/stripe-js';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';

// カード入力オプション（郵便番号は不要）
const CARD_OPTIONS: StripeCardElementOptions | undefined = {
  iconStyle: 'solid',
  hidePostalCode: true,
  style: {
    base: {
      iconColor: '#2196f3',
      color: '#000',
      fontWeight: 500,
      fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {
        color: '#2196f3',
      },
      '::placeholder': {
        color: '#2196f3',
      },
    },
    invalid: {
      iconColor: '#f50057',
      color: '#f50057',
    },
  },
};

// クレジットカード入力エレメント
const CardField = ({ onChange }: { onChange: any }) => (
  <div className='FormRow'>
    <CardElement options={CARD_OPTIONS} onChange={onChange} />
  </div>
);

interface Props {
  last4: string;
  expYear: string;
  expMonth: string;
  updating?: boolean;
  handleUpdate: (
    cardElement: StripeCardElement | StripeCardNumberElement,
  ) => void;
}
export default function CheckoutForm(props: Props) {
  const elements = useElements();
  const [last4, setLast4] = useState(props.last4);
  const [expYear, setExpYear] = useState(props.expYear);
  const [expMonth, setExpMonth] = useState(props.expMonth);

  const [error, setError] = useState<
    { type: 'validation_error'; code: string; message: string } | undefined
  >();
  const [cardComplete, setCardComplete] = useState(false);

  useEffect(() => {
    setLast4(props.last4);
    setExpYear(props.expYear);
    setExpMonth(props.expMonth);
  }, [props]);

  // 更新ボタンが押された
  const handleUpdate = (e: any) => {
    e.preventDefault();

    if (error) return;

    const cardElement = elements!.getElement(CardElement);

    // カード情報のチェック
    if (!cardComplete) {
      alert('カード情報が正しくありません。');
      cardElement!.focus();
      return;
    }

    props.handleUpdate(cardElement!);
  };

  return (
    <Stack spacing={2}>
      <Typography component='div' color='gray'>
        現在のカード [ **** **** **** {last4} {expMonth}/{expYear} ]
      </Typography>
      <CardField
        onChange={(e: StripeCardElementChangeEvent) => {
          setError(e.error);
          setCardComplete(e.complete);
        }}
      />
      <Button
        variant='outlined'
        color='primary'
        size='medium'
        onClick={handleUpdate}
        disabled={props.updating}
        startIcon={props.updating ? <CircularProgress size={20} /> : null}
      >
        {props.updating ? 'カード情報を更新中...' : 'カード情報を更新'}
      </Button>
    </Stack>
  );
}
